export class InternalTransferBaseRequest {
    masterAccountId: string;
    subAccountId: string;
}